import React from "react";
import { Container, Typography, Button, Box, Stack, Link, Card, CardContent, ImageList, ImageListItem, Grid2 } from "@mui/material";
import { motion } from "framer-motion";

const hotelesSede = [
    {
        nombre: "Hotel Casa Santo Domingo",
        direccion: "3ª Calle Oriente No.28, La Antigua Guatemala",
        descripcion: `Contamos con el servicio de transporte privado el cual tiene un costo de US$60.00 por 01 o 02 personas o US$30.00 por persona si son 3 o más por vía, si desean una silla infantil de transporte por favor indicarnos con anticipación (tiene costo adicional) y este los espera en el aeropuerto a la hora que usted lo desee. El costo puede variar si la dirección de destino es diferente. Para reservar su transporte únicamente necesito esta información:

1. Número y nombre de reserva del hotel.
2. Número de vuelo.
3. Hora que aterriza en Guatemala y fecha
4. Número de personas a viajar.

Importante:

Si hay algún atraso con su vuelo el piloto espera el tiempo necesario. Al confirmar el servicio, lo puede cancelar sin penalidad si lo informa al menos con 12 horas de anticipación ya que de lo contrario el mismo es cobrado como no show. El cargo se puede hacer a la habitación o lo solicitamos con anticipación.`,
        correo: "concierge@casasantodomingo.com.gt",
        linkReserva: "https://www.casasantodomingo.com.gt/book/dates-of-stay?groupID=4658287",
        imagenes: [
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/9c48f28b-149b-43f2-adb9-a546a13be678.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/b2378053-12ee-42c3-929c-99b710e920ba.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/afe1b9a6-82be-4671-9803-c813f667b9ed.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/d374aed8-69b1-4b67-94e0-bd7c6168db31.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/2c5ac1ea-94d1-45cf-8842-4f659c8c48e0.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/9e9aecad-ccbe-421c-8a9f-9554124fa75c.webp',
        ]
        ,
        ubicacion: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.7093836358176!2d-90.7304842242592!3d14.558604478102124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8589a22abb904243%3A0x7688f328c77074f0!2sHotel%20Museo%20Spa%20Casa%20Santo%20Domingo%20-%205%20estrellas%20-!5e0!3m2!1ses!2sgt!4v1744140546482!5m2!1ses!2sgt",
        title: "RESERVAR HOTEL SEDE"
    },

    {
        nombre: "Hotel Camino Real Antigua",
        direccion: "7a Calle Poniente 33B, La Antigua Guatemala",
        descripcion: `Tarifa de traslado:
USD 75.00 por vía, de 1 a 3 personas.
Aeorpuerto-hotel.
Coordinar con anticipación mínima de 2 días. 
Contacto: Narci Rivas
+502 5482 0856`,
        correo: "ventas_cra2@caminorealantigua.com.gt",
        linkReserva: "https://bookings.travelclick.com/106521?groupID=4654811#/guestsandrooms",
        imagenes: [
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/9f4e3086-c0bc-4b6d-97fc-6d8b55fad209.webp",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/72c8517c-b354-49d7-838c-b19c22c3e3ee.avif",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/e1aaf66c-7aae-42f0-95bf-0c12693801c1.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/70c74d3f-37dd-47bd-9ed8-71461111446f.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/48b5cc51-df46-4b14-a47a-4158607c4b61.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/cb4d7f96-fa83-44d3-b1ab-15cac960c832.jpeg"
        ],
        ubicacion: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.7962568690687!2d-90.73871992425924!3d14.553640678223442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85890e6dd2f9b43b%3A0x4bdbf0900b207393!2sCamino%20Real%20Antigua%20Guatemala!5e0!3m2!1ses!2sgt!4v1744140815138!5m2!1ses!2sgt',
        title: "RESERVAR HOTEL"
    },
    {
        nombre: "Porta Hotel Antigua",
        direccion: "8a Calle Poniente No.1, La Antigua Guatemala",
        descripcion: `Para nosotros es un gusto poner a su disposición nuestros servicios, la experiencia inolvidable de visitar un país inicia desde el momento en que sale del aeropuerto y se dirige al hotel electo, y para iniciar su experiencia inolvidable ofrecemos transporte privado con conductor profesional y vehículos asegurados del aeropuerto hacia La Antigua Guatemala o cualquier lugar que desee.

Aeropuerto - Antigua Guatemala USD 60.00 (1 o 2 personas)
Aeropuerto - Antigua Guatemala USD 25.00 Por persona (3 personas)
Aeropuerto - Antigua Guatemala USD 22.00 por persona (4-5 personas)
Aeropuerto – Antigua Guatemala USD 18.00 por persona (6-8 personas)

**Para grupos mayores de 9 personas se realizará cotización
**precios para una sola vía**

Para confirmar las reservas, necesitamos la siguiente información:
Nombre, No. teléfono, Fecha, Hora, Servicio, Pax: (No. de personas, Línea Aérea, Número de vuelo, Total, Forma de pago)
** FORMA DE PAGO encontrará el link correspondiente para que pueda realizar el pago en línea de su servicio
**este será enviando en la confirmación del servicio.
***Favor tomar en cuenta las políticas de cancelación***
Contacto: Lessly V. Robles
Correo: info@alacartatours.com
(+502) 78329636
(+502) 42905013 | (+502) 37614295 WhatsApp`,
        correo: "info@portahotels.com",
        linkReserva: "https://www.portahotelantigua.com/book/dates-of-stay?groupID=4662375",
        imagenes: [
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/7b50fb4a-7e3a-4132-a76a-b9d542e01277.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/d0cf1c62-55e6-49af-8616-8850f409d303.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/085ccd3d-7db0-4944-a100-fa2873d7c5d6.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/20eb71ff-6ccd-475f-89a1-460ea0b20887.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/dc3f27ca-6d80-468a-9068-fe7d9cbb3e69.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/f0faf480-b442-4836-8050-412d2cb9a375.jpeg"
        ],
        ubicacion: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.805083565557!2d-90.73857311567812!3d14.553136241969456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85890e72a7e528ed%3A0x15ce28f4b679dde2!2sPorta%20Hotel%20Antigua!5e0!3m2!1ses!2sgt!4v1744140881465!5m2!1ses!2sgt',
        title: "RESERVAR HOTEL"
    },
    {
        nombre: "Hotel Posada de Don Rodrigo",
        direccion: "Calle del Arco No.17 La Antigua Guatemala",
        descripcion: `Tarifa de traslado:
Traporte colectivo donde viene mas huspedes
$35.00 por viaje | Q280.00

Transporte privado solo para un huesped
$125.00 por viaje | Q1,000.00

Contacto:
Paola García
Correo: posadareservaciones@gmail.com
(+502) 7832 0387 7832 9858.`,
        correo: "reservas@posadadedonrodrigo.com",
        linkReserva: "https://api.whatsapp.com/send/?phone=50257090763&text&type=phone_number&app_absent=0",
        imagenes: [
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/ff7051ea-8dbd-44d4-a4ca-02bfdd095ff6.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/b420c6c5-7c5a-4f6f-a8fc-5ce98dce243d.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/426de907-ec69-4074-9fe7-7fcbc5107ac9.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/39c06340-3cbe-44c1-b69e-113f7a440fb6.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/2b40b5cb-d29b-4aa2-af8a-6b146b054c94.jpeg",
            "https://escuela-bancaria.s3.us-east-2.amazonaws.com/cee07663-464b-404b-b062-ed59adfe79d5.jpeg"
        ],
        ubicacion: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.708961782422!2d-90.73671142425914!3d14.558628578101567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8589a1b94f5fae91%3A0xe3f57f9559045d14!2sHotel%20Posada%20de%20Don%20Rodrigo%20Antigua!5e0!3m2!1ses!2sgt!4v1744140933638!5m2!1ses!2sgt',
        title: "RESERVAR HOTEL"
    },
    {
        nombre: "Otros Hoteles y Transportes",
        direccion: "¿Necesitas otra opción de hospedaje y transporte hacia Antigua Guatemala?",
        descripcion: `Haz Click en el enlace abajo para más información`,
        linkReserva: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/32b18826-f51e-416b-b011-02dc8f7b4dee.pdf",
        imagenes: [
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/85fa395e-9849-4752-971a-ca631d06efe9.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/d2ca8892-73bb-411a-be13-6635a2e959b0.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/d2b2e7ae-d26b-48cf-9e25-be6be3826032.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/72f35f66-7c59-4398-9246-123b32769608.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/77cffdd8-2b26-4518-b19b-598ba768d187.jpeg',
        ]
        ,
        title: "RESERVAR HOTEL"
    },
    {
        nombre: "Tours",
        direccion: "¡Explora Guatemala!",
        descripcion: `Haz Click en el enlace abajo para más información`,
        linkReserva: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/ecc227da-2b46-4dd6-a498-65320c844a96.jpeg",
        imagenes: [
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/ecd1b9dc-8556-459f-8b0b-cd50ac462867.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/12d815fe-b777-46b2-b056-b16101a64406.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/14a966e0-ece2-4d8c-846c-08cfa6857c87.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/919d6921-6a3e-4a26-9958-8d980592a1b4.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/65d66ee5-1a12-48a4-95cc-94e1116f9763.jpeg',
            'https://escuela-bancaria.s3.us-east-2.amazonaws.com/a4bab260-4000-438c-94a1-9393b6206b56.jpeg'
        ]
        ,
        title: "RESERVAR TOUR"
    },
]

const mailSubject = encodeURIComponent("RESERVACIÓN HOTEL COPLAFT GUATEMALA 2025");
const mailBody = encodeURIComponent("Hola, quisiera reservar una habitación para las fechas 22 y 23 de septiembre para el COPLAFT 2025.");

const Viaje = () => {
    return (
        <Box
            sx={{
                color: "white",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: 4,
            }}
        >
            <Container maxWidth>
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 1 }}
                >
                    <Typography color='#1f3f5d' variant="h2" fontWeight="bold" gutterBottom>
                        Información Importante para tu Viaje
                    </Typography>
                    <Typography color='#1f3f5d' variant="h5" sx={{ marginBottom: 2 }}>
                        Encuentra todo lo que necesitas saber sobre hoteles, transporte y tours en Antigua Guatemala.
                    </Typography>
                    <Typography color='#1f3f5d' variant="p" textAlign='justify' sx={{ marginBottom: 5 }}>
                        Tomar en cuenta que el Aeropuerto “La Aurora”, se encuentra ubicado en la Ciudad de Guatemala, nuestro evento
                        COPLAFT será realizado en “La Antigua Guatemala”. La distancia conduciendo entre Ciudad de Guatemala
                        y Antigua Guatemala es de 38 km. Dura aproximadamente entre 1 y 2 horas, dependiendo del tráfico y la hora.
                    </Typography>
                </motion.div>
                <Stack spacing={4} sx={{ width: '100%' }} alignItems="center" mt={5}>
                    {hotelesSede.map((hotel, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.8 }}
                            style={{ width: '100%' }}
                        >
                            {index == 1 && <Typography color='#1f3f5d' variant="h2" fontWeight="bold" gutterBottom>
                                Otros Hoteles
                            </Typography>}
                            <Grid2 container sx={{ backgroundColor: index % 2 == 0 ? "#272948" : "white", borderRadius: 2, margin: 'auto', }} style={{ textAlign: 'center' }} alignItems='center'>
                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                    <Card style={{ backgroundColor: 'transparent', width: '100%', color: index % 2 == 0 ? "white" : "#272948" }} elevation={0}>
                                        <CardContent style={{ textAlign: 'justify' }}>
                                            <Typography variant="h5" fontWeight="bold" gutterBottom>
                                                {index == 0 ? <strong>Hotel Sede – {hotel.nombre}</strong> : <strong>{hotel.nombre}</strong>}
                                            </Typography>
                                            <Typography variant="body1" paragraph>
                                                {hotel.direccion}
                                            </Typography>
                                            <Typography variant="body1" paragraph whiteSpace="pre-line">
                                                {hotel.descripcion}
                                            </Typography>
                                            {hotel.ubicacion != null && <iframe src={hotel.ubicacion} style={{ border: 0, width: '100%', height: '500px', padding: 15 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>}
                                            {hotel.correo != null && <Typography variant="body1" paragraph>
                                                Enlace e-mail:{" "}
                                                <Link
                                                    href={`mailto:${hotel.correo}?subject=${mailSubject}&body=${mailBody}`}
                                                    color="inherit"
                                                    underline="always"
                                                >
                                                    {hotel.correo}
                                                </Link>
                                            </Typography>}
                                            <Button
                                                variant="contained"
                                                href={hotel.linkReserva}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    mt: 1,
                                                    backgroundColor: "#3a3c5c",
                                                    color: "white",
                                                    borderRadius: 2,
                                                    '&:hover': {
                                                        backgroundColor: "#505272"
                                                    }
                                                }}
                                            >
                                                {hotel.title}
                                            </Button>
                                        </CardContent>
                                    </Card>
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                                    <motion.div
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true, amount: 0.3 }}
                                        transition={{ duration: 0.8 }}
                                        style={{ width: '100%', maxWidth: 800, margin: '20px auto 0' }}
                                    >
                                        <ImageList cols={2} gap={8}>
                                            {hotel.imagenes.map((img, i) => (
                                                <ImageListItem key={i}>
                                                    <img
                                                        src={img}
                                                        alt={`Imagen ${i + 1} de ${hotel.nombre}`}
                                                        loading="lazy"
                                                        style={{ borderRadius: 10 }}
                                                    />
                                                </ImageListItem>
                                            ))}
                                        </ImageList>
                                    </motion.div>
                                </Grid2>

                            </Grid2>


                        </motion.div>
                    ))}
                </Stack>
            </Container>
        </Box >
    );
};

export default Viaje;
